import { Attendee, CardOnFile } from "../../types/attendee";

/**
 * "Card on file" for an attendee means at least one ACTIVE card_on_files row.
 * Disabled cards (is_active = false, via the "Disable Card" action) do not count,
 * matching how the POS tab flow decides whether an attendee has a vaulted card.
 */
export type CardFilter = "all" | "with" | "without";

export const CARD_FILTER_OPTIONS: { value: CardFilter; label: string }[] = [
  { value: "all", label: "All" },
  { value: "with", label: "Card on file" },
  { value: "without", label: "No card" },
];

export const parseCardFilter = (raw: string | null): CardFilter =>
  raw === "with" || raw === "without" ? raw : "all";

/** Hasura bool_exp fragment: attendee has an active card on file. */
export const HAS_ACTIVE_CARD_WHERE = { card_on_files: { is_active: { _eq: true } } };

export const applyCardFilter = (where: Record<string, any>, filter: CardFilter): Record<string, any> => {
  if (filter === "with") return { _and: [where, HAS_ACTIVE_CARD_WHERE] };
  if (filter === "without") return { _and: [where, { _not: HAS_ACTIVE_CARD_WHERE }] };
  return where;
};

const CARD_TYPE_LABELS: Record<string, string> = {
  V: "Visa",
  M: "Mastercard",
  A: "Amex",
  D: "Discover",
};

export const activeCard = (attendee: Attendee): CardOnFile | undefined =>
  (attendee.card_on_files ?? []).find((c) => c.is_active);

export const cardTypeLabel = (card: CardOnFile): string =>
  card.card_type ? CARD_TYPE_LABELS[card.card_type.toUpperCase()] ?? card.card_type : "";

export const formatCard = (card: CardOnFile): string =>
  `•••• ${card.last_four_digits ?? "????"}`;
